// extracted by mini-css-extract-plugin
module.exports = {"default":"call-time-under-phone_default__3ciT0","header":"call-time-under-phone_header__2qgo_"};